module.exports = __webpack_public_path__ + "static/media/3-4.0d7cafb3.webp";